var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48688_14020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.7041C0 19.3315 5.37258 24.7041 12 24.7041C18.6274 24.7041 24 19.3315 24 12.7041C24 6.07668 18.6274 0.704102 12 0.704102C5.37258 0.704102 0 6.07668 0 12.7041Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7 9.77891C17.55 9.25391 17.175 8.87891 16.65 8.72891C15.75 8.50391 11.925 8.50391 11.925 8.50391C11.925 8.50391 8.175 8.50391 7.2 8.72891C6.675 8.87891 6.3 9.25391 6.15 9.77891C6 10.7539 6 12.7039 6 12.7039C6 12.7039 6 14.6539 6.225 15.6289C6.375 16.1539 6.75 16.5289 7.275 16.6789C8.175 16.9039 12 16.9039 12 16.9039C12 16.9039 15.75 16.9039 16.725 16.6789C17.25 16.5289 17.625 16.1539 17.775 15.6289C18 14.6539 18 12.7039 18 12.7039C18 12.7039 18 10.7539 17.7 9.77891ZM10.8 14.5039V10.9039L13.95 12.7039L10.8 14.5039Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48688_14020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.704102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6b477a249c188dbb8208a2f7f89f6cc1.svg";
export { ForwardRef as ReactComponent };